import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import styles from "./chat-input.module.less";
import {DebounceInput} from 'react-debounce-input';
import sendIcon from "@/assets/send-icon.svg";
import { ChatMsg } from "../../types/chat-msg-types";
import {USER_MSG, CONFIG, DETECT_UN_ACTIVITY, FEEDBACK, CUSTOMER_INACTIVE2} from "../../common/config";
import { addChatMsgAction, sendMessageAction, updateNotifyStatus, triggerInactivityAction, showLadingIconAction } from "../../actions/chat-msg-actions";
import { getChatbotSuggestionList, getClearInput, getShowSuggestion, getSuggestionInput } from "../../reducers/chat-suggestion-reducer";
import { querySuggestionListAction, filterSuggestionListAction, updateShowSuggestionAction, cleanSuggestionAction, clearInputAction, setInputAction, showSuggestionAction, setShowSuggestionFlagAction } from "../../actions/chat-suggestion-actions";
import {getFrontEndAction} from "../../reducers/chat-msg-reducer";
import { getChatCommon } from "src/reducers/chat-common-reducer";
import { CommonConstant } from "../../common/CommonConstant";

const ChatInput: React.FC = () => {
    const inputRef:any = React.createRef();
    const dispatch = useDispatch();
    let chatbotSuggestionList = useSelector(getChatbotSuggestionList);
    const showSuggestionFlag = useSelector(getShowSuggestion);
    const frontEndAction = useSelector(getFrontEndAction);
    const welcomeMsg = useSelector(getChatCommon);

    const clearInput = useSelector(getClearInput);
    const [inputValue, setInputValue] = useState<any>("");
    const [notifyTimer, setTimer] = useState<any>();
    const suggestionInput = useSelector(getSuggestionInput);
    const showSuggestion = (inputMessage: string) => {
        if (inputMessage !== "" && inputMessage.length >= +CONFIG.SHOW_SUGGESTION_CHARACTER) {
            dispatch(setShowSuggestionFlagAction(true));
            if (!chatbotSuggestionList || chatbotSuggestionList.length === 0) {
                dispatch(querySuggestionListAction(inputMessage));
            }
            dispatch(filterSuggestionListAction(true, inputMessage));
            dispatch(updateShowSuggestionAction(true));
        } else {
            dispatch(cleanSuggestionAction());
        }
    };
    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputMessage = e.target.value.replace(/^\s*/,"");   //trim space at the beginning of the string
        showSuggestion(inputMessage);
        dispatch(clearInputAction(false));
        dispatch(setInputAction(e.target.value.replace(/^\s*/,"")));
        setInputValue(e.target.value);
    };
    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.which === 13) {
            let suggestionFocused = sessionStorage.getItem("suggestionFocused");
            let sending = sessionStorage.getItem("messageSending");
            if (sending === "true") {
                sessionStorage.setItem("messageSending", "false");
            } else if (suggestionFocused != "true") {
                if (inputValue !== "") {
                    sessionStorage.setItem("messageSending", "true");
                    sendMsg();
                }
            }
        }
    };
    const sendMsg = () => {
        if (inputValue === "" || inputValue.trim() === "") {
            return;
        }

        dispatch(showLadingIconAction(true));

        const userMsg: ChatMsg = {msg: inputRef.current.value.trim(), type: USER_MSG, date: new Date()};
        dispatch(addChatMsgAction(userMsg));
        dispatch(setShowSuggestionFlagAction(false));
        dispatch(sendMessageAction({message: inputRef.current.value.trim(), name: inputRef.current.value.trim(), type: "typed"}));
        // }
        //clear the input value after send the msg
        setInputValue("");
        //if you already sent the message , then close the suggestion
        if(showSuggestionFlag) {
            dispatch(showSuggestionAction(false, []));
        }
    }
    useEffect(() => {
        if (clearInput) {
            setInputValue("");
        }
        startTimer();
    }, [clearInput]);
    useEffect(() => {
        if (suggestionInput) {
            setInputValue(suggestionInput);
        }
    }, [suggestionInput]);
    const startTimer = () => {
        console.log("start timer");

        if (notifyTimer) {
            clearInterval(notifyTimer)
        }
        const timer = setInterval(() => {
            const lastResponseTime = localStorage.getItem("lastResponseTime");
            console.log("----", CONFIG.INACTIVITY_TIME_TEN);

            if (lastResponseTime
                && (new Date().getTime() - Number.parseInt(lastResponseTime)) > Number.parseInt(CONFIG.INACTIVITY_TIME_TEN)
                && sessionStorage.getItem("needNotify") === "true"
            ) {
                // dispatch(updateSuggestionsTypeAction(undefined))
                if(sessionStorage.getItem(DETECT_UN_ACTIVITY) === "true") {
                    let payload = {
                        action: sendMessageAction({
                            message: CONFIG.UNACTIVITY_TRIGGER,
                            notSaveToMongo: true,
                            type: DETECT_UN_ACTIVITY,
                            forceLanguage:localStorage.getItem(CommonConstant.CURRENT_LANGUAGE)
                        })
                    }
                    dispatch(triggerInactivityAction(payload));
                }
                dispatch(updateNotifyStatus(true));
            }
            if(lastResponseTime
                && (new Date().getTime() - Number.parseInt(lastResponseTime)) > Number.parseInt(CONFIG.FEEDBACK_TIME_TEN)
                && sessionStorage.getItem("needNotify") === "false"
                && sessionStorage.getItem(DETECT_UN_ACTIVITY)==="false"
                && sessionStorage.getItem(FEEDBACK) === "true"
                ){
                    let payload = {
                    action: sendMessageAction({message:localStorage.getItem(CommonConstant.CURRENT_LANGUAGE) === CommonConstant.CHINESE_LANGUAGE?CONFIG.NOEND_CHINESE_CHAT: CONFIG.NOEND_CHAT, notSaveToMongo: true, type: CUSTOMER_INACTIVE2,forceLanguage:localStorage.getItem(CommonConstant.CURRENT_LANGUAGE)})
                    }
                    dispatch(triggerInactivityAction(payload));
                }
        }, 10000);
        setTimer(timer)
    };

    return (
        <div className={styles.ChatInputLess} data-testid="chatInputMessage">
            {showSuggestionFlag}
            <DebounceInput data-testid="debounceInput"
                debounceTimeout={200}
                forceNotifyByEnter={true}
                forceNotifyOnBlur={true}
                value={inputValue}
                placeholder={welcomeMsg.typingMessage != ""? welcomeMsg.typingMessage: CONFIG.TYPING_MESSAGE}
                onChange={handleInputChange}
                onKeyDown={handleKeyDown}
                className={showSuggestionFlag ? "chat-input-with-suggestion" : "chat-input"}
                inputRef={inputRef} />
            <button
                data-testid="sendIcon"
                className="send-icon"
                type="button"
                onClick={sendMsg}
                aria-label="Send message"
            >
                <img src={sendIcon} alt="" aria-hidden="true" />
            </button>
        </div>
    )
}

export default ChatInput;